/*
 * Transloco loader for inline translations
 * There are two ways to load a translation file:
 *
 * 1. Expects translation files to be in the ./assets/i18n folder
 * @param loader `(lang: string) => import(`./i18n/${lang}.json`)` to create a relative import to the correct dir
 *
 * @see {@link https://ngneat.github.io/transloco/docs/inline-loaders|Inline Loaders}
 *
 * 2. Using a dynamic import that first attempts to load from a brand-specific folder. If it fails it looks for fallback:
 * 
 *   const loaderFn = (lang: string, baseTranslationPath?: string, brandFolder?: string) =>
 *     import(`${baseTranslationPath}${brandFolder}/${lang}.json`).catch(() =>
 *     import(`${baseTranslationPath}/${lang}.json`)
 *   );
 *
 */

import { supportedLanguages } from '../constants';

export type TranslationLoaderFn = (
  languageCode: string,
  baseTranslationPath?: string,
  brandFolder?: string,
) => Promise<unknown>;

export const inlineLoaderFactory = (loader: TranslationLoaderFn, baseTranslationPath?: string, brandFolder?: string) => {
  return supportedLanguages.reduce((acc, language) => {
    acc[language] = () => loader(language, baseTranslationPath, brandFolder);
    return acc;
  }, {});
};
